import {addMinutes, formatISO} from "date-fns";

import {Token} from "@commons/models/domain/Token";

import {TokenModel} from "@shared/view-models/tokenModel";

export class TokenStore {

  private saveInLS = true;
  private readonly tokenLSKey = 'token';

  private _token?: TokenModel;

  get token(): Token | undefined {
    if (this.saveInLS && !this._token) {
      const item = localStorage.getItem(this.tokenLSKey);
      this._token = item ? JSON.parse(item) as Token : undefined;
    }
    return this._token ? this.getClone(this._token) : undefined;
  }


  constructor() {
  }

  private getClone(object: any): any {
    return JSON.parse(JSON.stringify(object));
  }

  private getTokenModel(newToken: Token): TokenModel {
    const newTokenClone = this.getClone(newToken);

    const tokenModel = {} as TokenModel;
    tokenModel.userRights = newTokenClone.userRights;
    tokenModel.clients = newTokenClone.clients;
    tokenModel.sessionId = newTokenClone.sessionId;
    tokenModel.packageName = newTokenClone.packageName;
    tokenModel.modules = newTokenClone.modules;
    tokenModel.validTo = formatISO(addMinutes(new Date(), 19));
    return tokenModel;
  }

  saveToken(newToken: Token, saveInLocalStorage: boolean) {
    this.saveInLS = saveInLocalStorage;
    this._token = this.getTokenModel(newToken);
    if (this.saveInLS) //token dla logowania linkiem nie jest zapisywany w LocalStorage
      localStorage.setItem(this.tokenLSKey, JSON.stringify(this._token));
  }

  extendTokenValidTo() {
    this.saveToken(this.token!, this.saveInLS);
  }

  removeToken() {
    if (this.saveInLS)
      localStorage.removeItem(this.tokenLSKey);
  }
}
